import { FC, useMemo } from "react";
import { useAppSelector } from "../../store";
import { Campaign } from "@vviinn/user-managment-client-ts";
import {
  BooleanVoidFunc,
  ChangeSelectHandler,
  VoidFunc,
} from "../../helpers/functions/types";
import { CollapsedFields } from "../../components/GeneralUI/CollapsedFields/CollapsedFields";
import { NamedSelect } from "../../ui/layout/molecules/NamedSelect";
import { capitalizeAssociatedPress } from "../../helpers/string/capitalize";
import { StyleVariant } from "../../ui/layout/molecules/types";
import { SUB_HEADER_STYLES } from "../../ui/layout/detailedPages/styles";

type VpdReferenceSiteWrapperProps = {
  selectedSiteId: Campaign["referenceSiteId"];
  setSelectedSiteId: VoidFunc<Campaign["referenceSiteId"]>;
  selectedCompanyId: Campaign["referenceCompanyId"];
  setSelectedCompanyId: VoidFunc<Campaign["referenceCompanyId"]>;
  active: boolean;
  toggleFields: BooleanVoidFunc;
  styleVariant?: StyleVariant;
};

export const VpdReferenceSiteWrapper: FC<VpdReferenceSiteWrapperProps> = ({
  selectedSiteId,
  setSelectedSiteId,
  selectedCompanyId,
  setSelectedCompanyId,
  active,
  toggleFields,
  styleVariant,
}) => {
  const accessibleCompanies = useAppSelector(
    (state) => state.sites.accessibleCompanies,
  );

  const selectedCompanySites = useMemo(
    () =>
      accessibleCompanies.find(
        ({ companyId }) => companyId === selectedCompanyId,
      )?.sites,
    [accessibleCompanies, selectedCompanyId],
  );

  const unemptyAccessibleCompanies = accessibleCompanies.filter(
    ({ sites }) => sites.length > 0,
  );

  const handleCompanyChange: ChangeSelectHandler = (target) => {
    const currentCompanyId = target.value;
    setSelectedCompanyId(currentCompanyId);

    const firstSiteId = unemptyAccessibleCompanies.find(
      ({ companyId }) => companyId === currentCompanyId,
    )?.sites[0]?.id;
    setSelectedSiteId(firstSiteId);
  };

  return (
    <CollapsedFields
      active={active}
      title="use custom site"
      resetFields={() => {
        toggleFields(false);
      }}
      activateFields={() => {
        toggleFields(true);
      }}
    >
      <h2 className={`p-4 text-left ${SUB_HEADER_STYLES}`}>Reference site</h2>
      {unemptyAccessibleCompanies.length > 1 && (
        <NamedSelect
          title={capitalizeAssociatedPress("select company")}
          options={unemptyAccessibleCompanies.map(({ companyId, name }) => ({
            title: name,
            value: companyId,
          }))}
          onChange={handleCompanyChange}
          value={selectedCompanyId}
          styleVariant={styleVariant}
        />
      )}

      {!!selectedCompanySites?.length && (
        <NamedSelect
          title={capitalizeAssociatedPress("select site")}
          options={selectedCompanySites.map(({ id, domain }) => ({
            title: domain,
            value: id.toString(),
          }))}
          onChange={(target) => setSelectedSiteId(parseInt(target.value))}
          value={selectedSiteId?.toString()}
          styleVariant={styleVariant}
        />
      )}
    </CollapsedFields>
  );
};
